import { Route } from '@angular/router';

export const COMPLAINTS_ROOT_REDIRECT: Route = {
	path: 'complaints-root',
	redirectTo: '/xpressadmin/complaints',
	pathMatch: 'full'
};
